import _typeof from "@babel/runtime/helpers/typeof";
import zhCN from "./locale/zh_CN";
import zhTW from "./locale/zh_TW";
import enUS from "./locale/en_US";
import moment from "moment";
import "moment/locale/zh-tw";
import "moment/locale/zh-cn";
import "moment/locale/en-gb"; // 语言标识与内部语言包关系

var LANG_MAP = {
  en: enUS,
  "zh-cn": zhCN,
  "zh-tw": zhTW
};
/**
 * @desc 获取语言包信息
 * @param localeVal locale属性值
 * @param momentSync 是否同步变更moment语言
 */

export function getLangInfo(localeVal) {
  var momentSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var lang = '',
      langMap = null;

  if (_typeof(localeVal) === "object") {
    if ('locale' in localeVal) {
      //兼容antd语言包对象，对象中存在locale属性则直接获取语言类型即可
      lang = localeVal.locale;
    } else if ('lang' in localeVal) {
      //兼容tinper的Locale组件语言包
      lang = localeVal.lang;
    } else {
      //直接引入DataPicker组件语言包对象暂不提供支持
      console.error('暂不支持语言包对象，请使用locale="zh-cn"或locale="en"等语言标识');
    }
  } else if (typeof localeVal === "string") {
    //4.x支持的语言标识
    lang = localeVal;
  }

  if (momentSync) {
    moment.locale(lang);
  }

  return {
    //默认中文
    lang: lang.toLowerCase() || 'zh-cn',
    //语言类型
    langMap: LANG_MAP[lang] || zhCN //语言关系包

  };
}
; //兼容处理props.locale = {locale:'zh-cn'}情况，修复props.locale='zh-cn'变为'en'时，moment实例locale没有同步更新的问题

export function updateValueLocale(localeVal, value) {
  var lang = '';

  if (typeof localeVal == 'string') {
    lang = localeVal;
  } else if (_typeof(localeVal) == 'object') {
    if ('locale' in localeVal) {
      lang = localeVal.locale;
    } else if ('lang' in localeVal) {
      lang = localeVal.lang;
    }
  }

  if (value && typeof value.locale == 'function') {
    value.locale(lang || 'zh-cn');
  }
} // /**
//  * @deprecated
//  * @param {*} lang 仅仅用于类antd中多语存在locale对象中存在locale属性
//  * @param {*} locale 可以传对象默认是zh-cn多语对象，也可以直接使用en这样字符串快捷多语切换
//  * @returns
//  */
// const getLang = (lang, locale) => {
//   if (!lang) {
//     if (typeof locale === "string") {
//       lang = locale
//     } else {
//       return locale
//     }
//   }
//   if (!lang in LANG_MAP) lang = "zh-cn"
//   return LANG_MAP[lang];
// }
// export default getLang;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/lang-utils.js